namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_form_edit, {

		background: {
			color: $mol_theme.card,
		},

		Form: {
			padding: $mol_gap.block,
		},
		
	} )
	
}
